import { useQuery } from '@tanstack/react-query'
import { httpClient } from '@/api/http-client'

async function validateSession(token: string) {
  const response = await httpClient('user-manager').get(
    '/v1/session/validate',
    {
      params: {
        access_token: token,
      },
    },
  )

  return response.data
}

export function useValidateSession() {
  const accessToken = localStorage.getItem('access_token') || undefined

  return useQuery({
    queryKey: ['session', accessToken],
    queryFn: () => validateSession(accessToken!),
    enabled: !!accessToken,
    staleTime: 15 * 60 * 1000,
    refetchOnWindowFocus: true,
  })
}
